import { render } from "./TenantLogo.vue?vue&type=template&id=174945ae"
import script from "./TenantLogo.vue?vue&type=script&lang=js"
export * from "./TenantLogo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__